import React from "react";

const OverviewPanel = ({
  gameName,
  formatLabel,
  tournament,
  registeredCount,
  storedRegisteredCount,
  entryTypeLabel,
  roundsCount,
  selectedRoundName,
  formatDateTime,
  backfillingRegisteredCount,
  backfillRegisteredCountResult,
  onBackfillRegisteredCount,
}) => {
  const countsMatch =
    storedRegisteredCount !== null && storedRegisteredCount === registeredCount;
  const syncStatusClass =
    backfillRegisteredCountResult?.failedCount > 0
      ? "danger"
      : countsMatch
      ? "success"
      : "warning";
  const syncStatusLabel =
    backfillRegisteredCountResult?.failedCount > 0
      ? "Sync failed"
      : countsMatch
      ? "In sync"
      : "Needs sync";

  return (
    <>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Game</div>
          <div className="stat-value">{gameName}</div>
          <div className="stat-meta">{formatLabel}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Prize pool</div>
          <div className="stat-value">₹{tournament.prizePool || 0}</div>
          <div className="stat-meta">{tournament.type}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Registrations</div>
          <div className="stat-value">{registeredCount}</div>
          <div className="stat-meta">{entryTypeLabel}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Rounds</div>
          <div className="stat-value">{roundsCount}</div>
          <div className="stat-meta">Configured</div>
        </div>
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-header">
            <h3>Schedule</h3>
          </div>
          <div className="detail-body">
            <div className="detail-row">
              <div className="detail-label">Starts</div>
              <div className="detail-value">
                {formatDateTime(tournament.startsOn)}
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Ends</div>
              <div className="detail-value">{formatDateTime(tournament.endsOn)}</div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Registration ends</div>
              <div className="detail-value">
                {formatDateTime(tournament.registrationEndsOn)}
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Check-in time</div>
              <div className="detail-value">
                {tournament.checkInTime || "TBD"}
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Structure</h3>
          </div>
          <div className="detail-body">
            <div className="detail-row">
              <div className="detail-label">Format</div>
              <div className="detail-value">{formatLabel}</div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Team size</div>
              <div className="detail-value">{tournament.minTeamSize || "N/A"}</div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Max registrations</div>
              <div className="detail-value">
                {tournament.maxRegistrations || "N/A"}
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Selected round</div>
              <div className="detail-value">{selectedRoundName || "None"}</div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Developer settings</h3>
            <span className="chip">Developer only</span>
          </div>
          <div className="detail-body">
            <div className="detail-row">
              <div className="detail-label">Live registrations</div>
              <div className="detail-value">{registeredCount}</div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Stored registeredCount</div>
              <div className="detail-value">
                {storedRegisteredCount === null ? "Missing" : storedRegisteredCount}
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">Sync status</div>
              <div className="detail-value">
                <span className={`status-pill ${syncStatusClass}`}>
                  {syncStatusLabel}
                </span>
              </div>
            </div>
            {backfillRegisteredCountResult ? (
              <div className="helper-text">
                Last run {backfillRegisteredCountResult.ranAt.toLocaleString()} ·
                processed {backfillRegisteredCountResult.processedCount} ·
                updated {backfillRegisteredCountResult.updatedCount} ·
                unchanged {backfillRegisteredCountResult.unchangedCount} ·
                failed {backfillRegisteredCountResult.failedCount}
              </div>
            ) : (
              <div className="helper-text">
                Syncs `tournaments/{tournament.id}.registeredCount` from the
                `registered` subcollection size.
              </div>
            )}
            <div className="inline-actions">
              <button
                type="button"
                className="button ghost"
                onClick={onBackfillRegisteredCount}
                disabled={backfillingRegisteredCount}
              >
                {backfillingRegisteredCount
                  ? "Backfilling..."
                  : "Backfill registeredCount"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OverviewPanel;
